import { ActionTree } from 'vuex';
import { IDataState } from '@/store/modules/data/state';
import { MutationTypes } from './mutation-types';

export default {
  [MutationTypes.SET_DATA]({ commit, state }, value: IDataState) {
    commit(MutationTypes.SET_DATA, value);

    return state;
  },
  [MutationTypes.GET_DATA]({ commit }, value: IDataState) {
    commit(MutationTypes.SET_DATA, value);
  },
} as ActionTree<IDataState, any>;
